import router from "../router";
import Auth from "../auth";
import Swal from "sweetalert2";

export default {
  namespaced: true,
  state: {
    data: [],
    pagination: {
      current: null,
      total: null,
      data: [],
    },
    reports: [],
    paginatedReports: {
      current: null,
      total: null,
      data: [],
    },
    roles: [
      { key: "ADMIN", label: "Administrator" },
      { key: "VENDOR", label: "Vendor" },
      { key: "CLIENT", label: "Client" },
    ],
    searchableUsers: [],
    user: {
      first: "",
      last: "",
      email: "",
      password: null,
      phone: null,
      occupation_id: null,
      active: false,
    },
    emailVerifiedLoading: false,
    userServicesLoading: false,
  },
  mutations: {
    SET_DATA: (state, data) => {
      state.data = data;
    },
    SET_PAGINATION: (state, data) => {
      state.pagination = data;
    },
    SET_PAGINATED_REPORTS: (state, data) => {
      state.paginatedReports = data;
    },
    SET_REPORTS_DATA: (state, data) => {
      state.reports = data;
    },
    SET_USER: (state, data) => {
      state.user = data;
    },
    SET_SEARCHABLE_USERS: (state, data) => {
      state.searchableUsers = data;
    },
    SET_EMAIL_VERIFIED_LOADING: (state, data) => {
      state.emailVerifiedLoading = data;
    },
    SET_USER_SERVICES_LOADING: (state, data) => {
      state.userServicesLoading = data;
    },
  },
  actions: {
    all: function ({ commit, dispatch, state }, payload) {
      let url = "users";
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.type) {
          url = `${url}&type=${payload.type}`;
        }
        if (payload.status) {
          url = `${url}&status=${payload.status}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
        if (payload.username) {
          url = `${url}&username=${payload.username}`;
        }
      }
      if (!payload || !payload.page) {
        commit("SET_LOADING_STATE", true, { root: true });
      }
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              if (payload && payload.page) {
                commit("SET_PAGINATION", {
                  total: res.data.total,
                  current: res.data.current_page,
                  data: [...state.pagination.data, ...res.data.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATION", {
                  total: res.data.total,
                  current: res.data.current_page,
                  data: res.data.data,
                });
              } else {
                commit("SET_DATA", res.data);
              }
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_LOADING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    get: function ({ commit, dispatch }, id) {
      this.$http
        .get(`users/${id}`)
        .then((res) => {
          if (res.status == 200) {
            commit("SET_USER", res.data);
            commit("SET_LOADING_STATE", false, { root: true });
          }
        })
        .catch((err) => {
          commit("SET_LOADING_STATE", false, { root: true });
          dispatch(
            "setError",
            {
              message:
                err.message ||
                "Something went wrong. Please refresh the page and try again",
              code: 1,
            },
            { root: true }
          );
        });
    },
    register: function ({ commit, dispatch }, data) {
      commit("SET_SAVING_STATE", true, { root: true });
      this.$http
        .post("users", data)
        .then((res) => {
          if (res.status == 200) {
            router.push("/login");
          }
          commit("SET_SAVING_STATE", false, { root: true });
        })
        .catch((err) => {
          if (((err || {}).data || {}).data) {
            const errors = [];
            Object.keys(err.data.data).forEach((key) => {
              errors.push(err.data.data[key][0]);
            });
            dispatch(
              "setError",
              {
                message: errors.join("<br>"),
                title: "Server Error",
              },
              { root: true }
            );
          } else {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
          }
        });
    },
    create: function ({ commit, dispatch }, data) {
      commit("SET_SAVING_STATE", true, { root: true });
      this.$http
        .post("users/add", data)
        .then((res) => {
          if (res.status == 200) {
            dispatch(
              "setSuccess",
              {
                message: "User Successfully Added",
                title: "Success",
              },
              { root: true }
            );
            router.push("/admin/users");
          } else {
            dispatch(
              "setError",
              {
                message:
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
          }
          commit("SET_SAVING_STATE", false, { root: true });
        })
        .catch((err) => {
          if (((err || {}).data || {}).data) {
            const errors = [];
            Object.keys(err.data.data).forEach((key) => {
              errors.push(err.data.data[key][0]);
            });
            dispatch(
              "setError",
              {
                message: errors.join("<br>"),
                title: "Server Error",
              },
              { root: true }
            );
          } else {
            dispatch(
              "setError",
              {
                message:
                  ((err || {}).data || {}).message ||
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                title: "Server Error",
              },
              { root: true }
            );
          }
        });
    },
    invite: function ({ dispatch }, data) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post("users/invite", data)
          .then((res) => {
            if (res.status == 200) {
              dispatch(
                "setSuccess",
                {
                  message: "Invitation Successfully Sent",
                  title: "Success",
                },
                { root: true }
              );
            } else {
              dispatch(
                "setError",
                {
                  message: "Something went wrong...",
                  title: "Server Error",
                },
                { root: true }
              );
            }
            resolve(res.status == 200);
          })
          .catch((err) => {
            if (((err || {}).data || {}).data) {
              const errors = [];
              Object.keys(err.data.data).forEach((key) => {
                errors.push(err.data.data[key][0]);
              });
              dispatch(
                "setError",
                {
                  message: errors.join("<br>"),
                  title: "Server Error",
                },
                { root: true }
              );
            } else {
              dispatch(
                "setError",
                {
                  message:
                    ((err || {}).data || {}).message ||
                    err.message ||
                    "Something went wrong...",
                  title: "Server Error",
                },
                { root: true }
              );
            }
            resolve(false);
          });
      });
    },
    update: function ({ commit, dispatch }, payload) {
      let data = {
        first: payload.data.first,
        last: payload.data.last,
        email: payload.data.email,
        role: payload.data.role,
        phone: payload.data.phone,
        active: payload.data.active,
        occupation: payload.data.occupation_id,
        enable_sending_sms: payload.data.enable_sending_sms,
        enable_sending_email: payload.data.enable_sending_email,
      };

      if (payload.data.password != "") {
        data.password = payload.data.password;
      }

      if (!payload.noRedirect) {
        this.$http.put(`users/${payload.id}`, data).then((res) => {
          if (res.status == 200) {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setSuccess",
              {
                message: "User Successfully Updated",
                title: "Success",
              },
              { root: true }
            );
            router.push("/admin/users");
          }
        });
      } else {
        let vm = this;
        return new Promise(function (resolve) {
          vm.$http
            .put(`users/${payload.id}`, data)
            .then((res) => {
              if (res.status == 200) {
                commit("SET_SAVING_STATE", false, { root: true });
                return resolve(true);
              }
              return resolve(false);
            })
            .catch((err) => {
              Swal.fire({
                title: "Error",
                text: ((err.data || {}).error || err.error || {}).message,
                type: "error",
              });
              return resolve(false);
            });
        });
      }
    },
    updateAccount: function ({ commit, dispatch }, payload) {
      let data = {
        first: payload.data.first,
        last: payload.data.last,
        email: payload.data.email,
        phone: payload.data.phone,
        occupation: payload.data.occupation_id,
        enable_sending_sms: payload.data.enable_sending_sms,
        enable_sending_email: payload.data.enable_sending_email,
      };

      if (payload.data.password != "") {
        data.password = payload.data.password;
      }

      this.$http
        .put(`account/${payload.id}`, data)
        .then((res) => {
          if (res.status == 200) {
            localStorage.removeItem("C3:USER");
            Auth.getUser(localStorage.getItem("C3:JWT")).then((res) => {
              commit("SET_SAVING_STATE", false, { root: true });
              dispatch(
                "setSuccess",
                {
                  message: "Account Successfully Updated",
                  title: "Success",
                },
                { root: true }
              );
            });
          }
        })
        .catch((err) => {
          if (err.data.message) {
            let msg = [];
            let title = err.data.message;
            Object.values(err.data.data).filter((e) => {
              msg.push(...e);
            });
            if (msg.length == 0) {
              msg = "";
            } else {
              msg = msg.join("<br>");
            }
            dispatch(
              "setError",
              {
                message: msg,
                title: title,
              },
              { root: true }
            );
          }
          commit("SET_SAVING_STATE", false, { root: true });
        });
    },
    becomeVendor: function ({ commit, dispatch }, payload) {
      commit("SET_SAVING_STATE", true, { root: true });
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .post(`users/request/vendor`, payload)
          .then((res) => {
            if (res.status == 200) {
              Swal.fire({
                title: "Become a Vendor",
                text: "Your request has been sent",
                type: "success",
              });
            }
            commit("SET_SAVING_STATE", false, { root: true });
            return resolve(true);
          })
          .catch((err) => {
            commit("SET_SAVING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    delete: function ({ state, commit }, id) {
      this.$http.delete(`users/${id}`).then(() => {
        let data = state.data.filter((d) => {
          return d.id != id;
        });
        state.data = data;

        const newData = state.pagination.data.filter((item) => item.id != id);
        commit("SET_PAGINATION", {
          total: state.pagination.total - 1,
          current: state.pagination.current,
          data: newData,
        });
      });
    },
    getUsersForSearch: function ({ commit }) {
      this.$http.get("users/search").then((res) => {
        if (res.status == 200) {
          commit("SET_SEARCHABLE_USERS", res.data);
        }
      });
    },
    createUserReport: function ({}, payload) {
      let vm = this;
      return new Promise(function (resolve, reject) {
        vm.$http
          .post(`reports/create`, payload)
          .then((res) => {
            if (res.status == 200) {
              return resolve(res);
            }
            return reject(res);
          })
          .catch((err) => {
            return reject(err);
          });
      });
    },
    getUserReports: function ({ dispatch }, id) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(`reports/user/${id}`)
          .then((res) => {
            if (res.status == 200) {
              return resolve(res.data.data);
            }
            dispatch(
              "setError",
              {
                message:
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    changeReportStatus: function ({ dispatch }, payload) {
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .put(`report/status/${payload.id}`, { status: payload.status })
          .then((res) => {
            if (res.status == 200) {
              return resolve(true);
            }
            dispatch(
              "setError",
              {
                message:
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          })
          .catch((err) => {
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve(false);
          });
      });
    },
    getAllReports: function ({ commit, dispatch, state }, payload) {
      let url = "reports/view";
      if (payload) {
        if (payload.limit) {
          url = `${url}?limit=${payload.limit}`;
        }
        if (payload.status || payload.status == 0) {
          url = `${url}&status=${payload.status}`;
        }
        if (payload.page) {
          url = `${url}&page=${payload.page}`;
        }
      }
      if (!payload || !payload.page) {
        commit("SET_LOADING_STATE", true, { root: true });
      }
      let vm = this;
      return new Promise(function (resolve) {
        vm.$http
          .get(url)
          .then((res) => {
            if (res.status == 200) {
              res = res.data.data;
              if (payload && payload.page) {
                commit("SET_PAGINATED_REPORTS", {
                  total: res.total,
                  current: res.current_page,
                  data: [...state.paginatedReports.data, ...res.data],
                });
              } else if (payload && payload.limit) {
                commit("SET_PAGINATED_REPORTS", {
                  total: res.total,
                  current: res.current_page,
                  data: res.data,
                });
              } else {
                commit("SET_REPORTS_DATA", res.data);
              }
              commit("SET_LOADING_STATE", false, { root: true });
              return resolve();
            }
            return resolve();
          })
          .catch((err) => {
            commit("SET_LOADING_STATE", false, { root: true });
            dispatch(
              "setError",
              {
                message:
                  err.message ||
                  "Something went wrong. Please refresh the page and try again",
                code: 1,
              },
              { root: true }
            );
            return resolve();
          });
      });
    },
    makeEmailVerified: function ({ commit }, payload) {
      const vm = this;
      commit("SET_EMAIL_VERIFIED_LOADING", true);
      return new Promise(function (resolve) {
        vm.$http
          .put(`make-email-verified/${payload.id}`)
          .then((res) => {
            commit("SET_EMAIL_VERIFIED_LOADING", false);
            if (res.status == 200) {
              Swal.fire({
                title: "Success",
                text: res.data.message,
                type: "success",
              });
              resolve(res);
            }
          })
          .catch((err) => {
            commit("SET_EMAIL_VERIFIED_LOADING", false);
            Swal.fire({
              title: "Error",
              text:
                ((err.data || {}).error || err.error || {}).message ||
                "Something went wrong. Please refresh the page and try again",
              type: "error",
            });
            resolve(false);
          });
      });
    },
    getUserServices: function ({ commit }, payload) {
      commit("SET_USER_SERVICES_LOADING", true);
      const vm = this;
      return new Promise((resolve) => {
        vm.$http
          .get(`users/services/${payload.id}`)
          .then((res) => {
            commit("SET_USER_SERVICES_LOADING", false);
            if (res.status == 200) {
              resolve(res.data.data);
            }
          })
          .catch((err) => {
            commit("SET_USER_SERVICES_LOADING", false);
            Swal.fire({
              title: "Error",
              text:
                ((err.data || {}).error || err.error || {}).message ||
                "Something went wrong. Please refresh the page and try again",
              type: "error",
            });
            resolve(false);
          });
      });
    },
  },
};
